import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';

// Layout Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';

// Public Pages
import Home from './pages/Home';
import Windsurfing from './pages/Windsurfing';
import Kitesurfing from './pages/Kitesurfing';
import Wingfoiling from './pages/Wingfoiling';
import Center from './pages/Center';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Hotels from './pages/Hotels';
import Prices from './pages/Prices';
import Contact from './pages/Contact';
import Live from './pages/Live';
import Booking from './pages/Booking';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import PackingList from './pages/PackingList';

// Admin Pages
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminNews from './admin/AdminNews';
import AdminContacts from './admin/AdminContacts';
import AdminTeam from './admin/AdminTeam';
import AdminPartners from './admin/AdminPartners';
import AdminInfoAlerts from './admin/AdminInfoAlerts';
import AdminPrices from './admin/AdminPrices';
import AdminImages from './admin/AdminImages';
import AdminSettings from './admin/AdminSettings';
import AdminSocialMedia from './admin/AdminSocialMedia';

import './App.css';

// Public Layout Wrapper
const PublicLayout = ({ children }) => {
  return (
    <>
      <Navigation />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <LanguageProvider>
          <CookieConsentProvider>
            <div className="App">
              <CookieBanner />
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                <Route path="/windsurfing" element={<PublicLayout><Windsurfing /></PublicLayout>} />
                <Route path="/kitesurfing" element={<PublicLayout><Kitesurfing /></PublicLayout>} />
                <Route path="/wingfoiling" element={<PublicLayout><Wingfoiling /></PublicLayout>} />
                <Route path="/center" element={<PublicLayout><Center /></PublicLayout>} />
                <Route path="/news" element={<PublicLayout><News /></PublicLayout>} />
                <Route path="/news/:id" element={<PublicLayout><NewsDetail /></PublicLayout>} />
                <Route path="/live" element={<PublicLayout><Live /></PublicLayout>} />
                <Route path="/hotels" element={<PublicLayout><Hotels /></PublicLayout>} />
                <Route path="/prices" element={<PublicLayout><Prices /></PublicLayout>} />
                <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                <Route path="/booking" element={<Navigate to="/contact" replace />} />
                <Route path="/packliste" element={<PublicLayout><PackingList /></PublicLayout>} />
                <Route path="/packing-list" element={<Navigate to="/packliste" replace />} />
                <Route path="/impressum" element={<PublicLayout><Impressum /></PublicLayout>} />
                <Route path="/datenschutz" element={<PublicLayout><Datenschutz /></PublicLayout>} />

                {/* Admin Routes */}
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/*" element={<AdminLayout />}>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="news" element={<AdminNews />} />
                  <Route path="contacts" element={<AdminContacts />} />
                  <Route path="team" element={<AdminTeam />} />
                  <Route path="partners" element={<AdminPartners />} />
                  <Route path="info-alerts" element={<AdminInfoAlerts />} />
                  <Route path="prices" element={<AdminPrices />} />
                  <Route path="images" element={<AdminImages />} />
                  <Route path="social-media" element={<AdminSocialMedia />} />
                  <Route path="settings" element={<AdminSettings />} />
                </Route>

                {/* Redirect any unknown routes to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </CookieConsentProvider>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
